var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-container',{attrs:{"overlay":_vm.loading,"container":true}},[_c('h1',[_vm._v("пока ничего нет")])])}
var staticRenderFns = []

export { render, staticRenderFns }